import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormTransports } from './FormTransports';
// import { DeleteTransports } from './DeleteTransports';
import { Dialog } from 'primereact/dialog';

export const ModalTransports = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        loading, validaciones,
        name, abbreviation, code, handleInputChange,
        saveCreate, saveUpdate,
    } = props;


    const footer = (
        <div
            className='mt-2'
            style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px"
            }}
        >

            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                Guardando...
                            </>
                        )
                        : "Confirmar"
                }
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
                disabled={loading}
            >
                Cancelar
            </Button>

        </div>
    );


    return (
        <Dialog
            // header={modalTitle} 
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-tint f-20"></i>

                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}
        >
            {
                method === "create"
                    ? <FormTransports
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTransports
                            button={ModalButtonUpdate}
                            {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation, code }} />
                        :
                        null
            }
        </Dialog>
    )
}
